import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toJSONorString'
})
export class ToJsonOrStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }
    return value.toString();

  }

}
